import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";

export function AdminLogin() {
  const { login } = useStore();
  const navigate = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const u = await login(f.email, f.password);
      if (u.role !== "admin") { toast.error("This account is not an admin."); return; }
      toast.success("Welcome back, Kerry!");
      navigate("/admin");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-blush/30 px-4">
      <div className="bg-white border border-brand-border rounded-sm p-10 w-full max-w-sm">
        <div className="text-center mb-8"><div className="font-serif-display text-3xl">Crochet Kerry</div><p className="text-xs uppercase tracking-luxe text-brand-pink mt-2">Admin</p></div>
        <form onSubmit={submit} className="space-y-4">
          <input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="w-full border border-brand-border rounded-sm px-3 py-2.5 text-sm outline-none focus:border-brand-pink" data-testid="admin-email" />
          <input required type="password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="w-full border border-brand-border rounded-sm px-3 py-2.5 text-sm outline-none focus:border-brand-pink" data-testid="admin-password" />
          <button className="w-full bg-brand-ink text-white py-3 rounded-sm text-sm uppercase tracking-luxe hover:bg-brand-pink hover:text-brand-ink transition-colors" data-testid="admin-login-submit">Sign in</button>
        </form>
      </div>
    </div>
  );
}

export function ImageUploader({ value = [], onChange, single = false }) {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const files = [...e.target.files];
    if (!files.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (const file of files) {
        const fd = new FormData(); fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(data.url);
      }
      onChange(single ? urls[0] : [...(value || []), ...urls]);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const arr = single ? (value ? [value] : []) : value;
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {arr.map((url, i) => (
          <div key={i} className="relative w-20 h-20">
            <img src={url} alt="" className="w-full h-full object-cover rounded-sm border border-brand-border" />
            <button type="button" onClick={() => onChange(single ? "" : value.filter((_, x) => x !== i))} className="absolute -top-2 -right-2 bg-brand-ink text-white rounded-full w-5 h-5 flex items-center justify-center"><X className="w-3 h-3" /></button>
          </div>
        ))}
        <label className="w-20 h-20 border-2 border-dashed border-brand-border rounded-sm flex items-center justify-center cursor-pointer hover:border-brand-pink">
          <Upload className="w-5 h-5 text-muted-foreground" />
          <input type="file" accept="image/*" multiple={!single} onChange={upload} className="hidden" data-testid="image-upload-input" />
        </label>
      </div>
      {busy && <p className="text-xs text-muted-foreground">Uploading…</p>}
      <p className="text-xs text-muted-foreground">Or paste image URLs in the field below (comma separated).</p>
    </div>
  );
}
